(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["plazoentrega"] && !Shopify.designMode) return;
  try {
    /* Plazo de entrega · Stock Padel
 * Calcula en el navegador la fecha de entrega según el país, la hora de corte de cada
 * transportista (hora de Madrid), los fines de semana y los festivos.
 * Sin dependencias. Las funciones de cálculo se exportan para poder probarlas con Node.
 */
(function () {
  'use strict';

  // Texto del distintivo cuando no se ha subido el logo del transportista.
  var CARRIER_LABELS = { gls: 'GLS', ctt: 'CTT', ups: 'UPS', dhl: 'DHL', fedex: 'FedEx', cex: 'CEX' };

  var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');

  var DEFAULT_CONFIG = {
    timezone: 'Europe/Madrid',
    cutoffs: { gls: '18:00', ctt: '17:00', ups: '13:00', dhl: '13:00', fedex: '13:00', cex: '17:00' },
    // Festivos de salida (nacionales, Andalucía y Córdoba). Editables desde el tema.
    holidays: [],
    // Entrega en sábado (GLS península): solo entre estas fechas y para pedidos que salen en viernes.
    saturday: { enabled: false, from: '', to: '', name: '' },
    baleares: { enabled: true, name: '' },
    rules: [
      { countries: ['ES'], options: [
        { carrier: 'gls', name: 'GLS Peninsula', min: 1, max: 2 },
        { carrier: 'gls', name: 'GLS Express', min: 1, max: 1, before: '14:00' },
        { carrier: 'gls', name: 'GLS Sábado', saturday: true },
        { carrier: 'ctt', name: 'Ctt Baleares 48', min: 2, max: 3, region: 'baleares' }
      ] },
      { countries: ['PT'], options: [
        { carrier: 'ctt', name: 'Ctt Express 48', min: 1, max: 2 },
        { carrier: 'ctt', name: 'Ctt Express 24h', min: 1, max: 1 }
      ] },
      { countries: ['FR'], options: [
        { carrier: 'gls', name: 'GLS Europe', min: 2, max: 3 },
        { carrier: 'ups', name: 'UPS Express Saver UE', min: 1, max: 2 }
      ] },
      { countries: ['DE', 'IT', 'BE', 'NL', 'AT', 'LU'], options: [
        { carrier: 'gls', name: 'GLS Europe', min: 3, max: 5 },
        { carrier: 'ups', name: 'UPS Express Saver UE', min: 1, max: 2 }
      ] },
      { countries: EU, options: [
        { carrier: 'gls', name: 'GLS Europe', min: 4, max: 6 },
        { carrier: 'ups', name: 'UPS Express Saver UE', min: 1, max: 2 }
      ] },
      { countries: ['*'], options: [
        { carrier: 'ups', name: 'UPS Express Saver', min: 3, max: 5 }
      ] }
    ]
  };

  // ---- Fechas "civiles" (sin hora) representadas como Date UTC a medianoche ----

  function civil(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDays(date, n) { return new Date(date.getTime() + n * 86400000); }
  function iso(date) { return date.toISOString().slice(0, 10); }
  function toMinutes(hhmm) { var p = String(hhmm).split(':'); return (+p[0]) * 60 + (+(p[1] || 0)); }

  // Fecha y hora actuales en la zona horaria del almacén.
  function nowIn(timezone, now) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { date: civil(+parts.year, +parts.month, +parts.day), minutes: (+parts.hour) * 60 + (+parts.minute) };
  }

  function isBusinessDay(date, holidaySet) {
    var wd = date.getUTCDay();
    return wd !== 0 && wd !== 6 && !holidaySet[iso(date)];
  }

  function nextBusinessDay(date, holidaySet) {
    var d = addDays(date, 1);
    while (!isBusinessDay(d, holidaySet)) d = addDays(d, 1);
    return d;
  }

  function addBusinessDays(date, n, holidaySet) {
    var d = date;
    for (var i = 0; i < n; i++) d = nextBusinessDay(d, holidaySet);
    return d;
  }

  // Día en que sale el paquete: hoy si es hábil y no ha pasado el corte; si no, el siguiente hábil.
  function shipDate(now, cutoffMinutes, holidaySet) {
    if (isBusinessDay(now.date, holidaySet) && now.minutes < cutoffMinutes) return now.date;
    return nextBusinessDay(now.date, holidaySet);
  }

  function findOptions(config, country) {
    for (var i = 0; i < config.rules.length; i++) {
      var r = config.rules[i];
      if (r.countries.indexOf(country) !== -1) return r.options;
    }
    for (var j = 0; j < config.rules.length; j++) {
      if (config.rules[j].countries.indexOf('*') !== -1) return config.rules[j].options;
    }
    return null;
  }

  /**
   * Calcula los plazos para un país.
   * @returns {null | { shipsToday, minutesLeft, ship, options: [{carrier, name, before, from, to}] }}
   */
  function estimate(config, country, now) {
    var options = findOptions(config, country);
    if (!options || !options.length) return null;
    var holidaySet = {};
    (config.holidays || []).forEach(function (h) { holidaySet[h] = true; });
    var current = nowIn(config.timezone, now);

    var result = [];
    options.forEach(function (o) {
      var cutoff = toMinutes(config.cutoffs[o.carrier] || '00:00');
      var ship = shipDate(current, cutoff, holidaySet);
      var from, to, name = o.name;
      if (o.saturday) {
        var sat = config.saturday || {};
        var today = iso(current.date);
        if (!sat.enabled || (sat.from && today < sat.from) || (sat.to && today > sat.to)) return;
        if (ship.getUTCDay() !== 5) return; // solo tiene sentido si sale un viernes
        from = to = addDays(ship, 1);
        if (sat.to && iso(from) > sat.to) return;
        name = sat.name || name;
      } else {
        if (o.region === 'baleares') {
          if (config.baleares && config.baleares.enabled === false) return;
          name = (config.baleares && config.baleares.name) || name;
        }
        from = addBusinessDays(ship, o.min, holidaySet);
        to = addBusinessDays(ship, o.max, holidaySet);
      }
      result.push({
        carrier: o.carrier,
        name: name,
        region: o.region || null,
        before: o.before || null,
        ship: ship,
        cutoff: cutoff,
        from: from,
        to: to
      });
    });

    // La cuenta atrás va con la primera opción (el envío estándar).
    var main = result[0];
    var shipsToday = iso(main.ship) === iso(current.date);
    return {
      today: current.date,
      shipsToday: shipsToday,
      minutesLeft: shipsToday ? main.cutoff - current.minutes : 0,
      ship: main.ship,
      options: result
    };
  }

  // ---- Presentación ----

  // "jue 22", "Di 27", "sex 23", "Tue 27"; con mes: "vie 30 oct". Siempre día de la semana corto delante.
  function fmtDay(date, locale, withMonth) {
    var part = function (opts) {
      opts.timeZone = 'UTC';
      var v = new Intl.DateTimeFormat(locale, opts).format(date).replace(/[.,]/g, '').trim();
      return v.length > 4 ? v.slice(0, 3) : v;
    };
    var out = part({ weekday: 'short' }) + ' ' + date.getUTCDate();
    return withMonth ? out + ' ' + part({ month: 'short' }) : out;
  }

  function fmtRange(from, to, locale) {
    var crossMonth = from.getUTCMonth() !== to.getUTCMonth();
    if (iso(from) === iso(to)) return fmtDay(from, locale, false);
    return fmtDay(from, locale, crossMonth) + ' – ' + fmtDay(to, locale, crossMonth);
  }

  function fmtCountdown(minutes, t) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return h > 0 ? t.hours.replace('{h}', h).replace('{m}', m) : t.minutes.replace('{m}', m);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(el, data, cfg) {
    var t = cfg.t;
    var tomorrow = iso(addDays(data.today, 1));
    var head = data.shipsToday
      ? t.countdown.replace('{time}', '<b>' + fmtCountdown(data.minutesLeft, t) + '</b>')
      : t.shipsOn.replace('{day}', '<b>' + escapeHtml(fmtDay(data.ship, cfg.locale, false)) + '</b>');

    var rows = data.options.map(function (o) {
      var when;
      if (iso(o.from) === iso(o.to) && iso(o.from) === tomorrow) {
        // Con hora ("antes de las 14:00") basta "Mañana"; sin hora se añade el día para que no haya dudas.
        when = o.before ? t.tomorrow : t.tomorrow + ', ' + fmtDay(o.from, cfg.locale, false);
      }
      else {
        when = fmtRange(o.from, o.to, cfg.locale);
      }
      if (o.before && iso(o.from) === iso(o.to)) when += ' ' + t.before.replace('{time}', o.before);
      var label = CARRIER_LABELS[o.carrier] || o.carrier.toUpperCase();
      var logo = cfg.logos[o.carrier]
        ? '<img class="spd-logo" src="' + cfg.logos[o.carrier] + '" alt="' + escapeHtml(label) + '" width="36" height="16" loading="lazy">'
        : '<span class="spd-logo spd-logo--' + o.carrier + '">' + escapeHtml(label) + '</span>';
      var region = o.region && t[o.region] ? '<span class="spd-name">' + escapeHtml(t[o.region]) + ':</span> ' : '';
      return '<div class="spd-row' + (o.region ? ' spd-row--small' : '') + '">' + logo +
        '<span>' + region + '<b>' + escapeHtml(when) + '</b> <span class="spd-name">· ' + escapeHtml(o.name) + '</span></span></div>';
    }).join('');

    el.innerHTML = '<div class="spd-top"><span aria-hidden="true">⏱</span> <span>' + head + '</span></div>' + rows;
  }

  // ---- Arranque en la tienda ----

  function init(el) {
    if (el.getAttribute('data-spd-ready')) return;
    el.setAttribute('data-spd-ready', '1');
    var cfg;
    try { cfg = JSON.parse(el.querySelector('script[type="application/json"]').textContent); } catch (e) { el.hidden = true; return; }
    var config = mergeConfig(DEFAULT_CONFIG, cfg.config);
    var body = el.querySelector('.spd-body');
    var available = cfg.variants || {};
    var scope = el.closest('.shopify-section') || document;
    var form = scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');

    function currentVariantId() {
      var input = form && form.querySelector('[name="id"]');
      var fromUrl = new URLSearchParams(location.search).get('variant');
      return (input && input.value) || fromUrl || cfg.initialVariant;
    }

    function update() {
      var id = String(currentVariantId());
      var inStock = available[id] !== undefined ? available[id] : true;
      var data = inStock ? estimate(config, cfg.country) : null;
      if (!data) { el.hidden = true; return; }
      el.hidden = false;
      render(body, data, cfg);
    }

    update();
    setInterval(update, 30000);
    // Horizon emite "variant:update" al cambiar de talla/color; el resto de temas, un "change" en el formulario.
    document.addEventListener('variant:update', function () { setTimeout(update, 0); });
    if (form) form.addEventListener('change', function () { setTimeout(update, 0); });
  }

  function mergeConfig(base, override) {
    if (!override) return base;
    var out = {};
    Object.keys(base).forEach(function (k) { out[k] = base[k]; });
    Object.keys(override).forEach(function (k) {
      if (override[k] !== null && override[k] !== undefined && override[k] !== '') out[k] = override[k];
    });
    out.cutoffs = Object.assign({}, base.cutoffs, override.cutoffs || {});
    out.saturday = Object.assign({}, base.saturday, override.saturday || {});
    out.baleares = Object.assign({}, base.baleares, override.baleares || {});
    return out;
  }

  var api = { DEFAULT_CONFIG: DEFAULT_CONFIG, estimate: estimate, fmtRange: fmtRange, mergeConfig: mergeConfig, civil: civil, iso: iso };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') {
    var start = function () { document.querySelectorAll('[data-sp-delivery]').forEach(init); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    // En el editor del tema los bloques se añaden y recargan sin recargar la página.
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:block:select', start);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
